import { Pipe, PipeTransform } from '@angular/core'
import * as moment from 'moment'

@Pipe({ name: 'formatYear' })
export class FormatYearPipe implements PipeTransform {
    transform(value: any): string {
        return moment(value).format('YYYY')
    }
}
